import { render, staticRenderFns } from "./config.vue.html?vue&type=template&id=8608ab6c"
import script from "./config.controller.ts?vue&type=script&lang=js&external"
export * from "./config.controller.ts?vue&type=script&lang=js&external"
import style0 from "./config.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports